<div class="preview-container">
    <app-dashboard-panel-add-form
        [hidden]="!isPreviewHide"
        (onPanelSelected)="handleAddPanelSelection($event)"
        (onPreviewClick)="onPreviewClick()"
        (onClose)="emitClose()"
        (onSave)="handleSaveClicked()"
    ></app-dashboard-panel-add-form>
    <div class="preview" [hidden]="shouldHidePreview() && isPreviewHide">
        <div class="button-wrap" *ngIf="isPreviewHide">
            <button
                data-cy="dashboard-custom-page-cancel-button"
                class="caption transparent highlighted-text"
                (click)="emitClose()"
            >
                {{ "dashboard.forms.add-panel.labels.cancel" | translate }}
            </button>
            <button
                data-cy="dashboard-custom-page-save-button"
                class="caption primary"
                (click)="handleSaveClicked()"
                [disabled]="!selectedPanel.type"
            >
                {{ "dashboard.forms.add-panel.labels.save" | translate }}
            </button>
        </div>
        <div class="button-wrap" *ngIf="!isPreviewHide">
            <button class="caption primary" (click)="onPreviewClick()">
                {{ "dashboard.forms.add-panel.labels.close" | translate }}
            </button>
        </div>
        <div class="preview-view-container">
            <div class="preview-view-header">
                <div
                    data-cy="dashboard-custom-page-preview-title"
                    class="subtitle bold"
                >
                    {{ "dashboard.forms.preview.header" | translate }}
                </div>
                <div
                    data-cy="dashboard-custom-page-preview-info-text"
                    class="text"
                >
                    {{ "dashboard.forms.preview.info" | translate }}
                </div>
            </div>

            <div class="preview-view">
                <div #container class="panel panel-content"></div>
                <div
                    data-cy="dashboard-custom-page-deselect-button"
                    class="remove-wrap"
                    *ngIf="selectedPanel.type"
                    (click)="removeSelectedPanel()"
                >
                    <mat-icon
                        svgIcon="delete"
                        style="width: 24px; height: 24px"
                    />
                    <div>
                        {{ "dashboard.panel.labels.deselect" | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-pop-up-notification
    style="left: 0"
    #notification
    [message]="'dlg.dashboard.preview.msg'"
    [closeButton]="'dashboard.forms.add-panel.labels.close'"
    [ngClass]="getNotificationVisible() ? 'show' : ''"
></app-pop-up-notification>

<app-confirmation-window
    #discardChangesOverlay
    [mainLabel]="'dashboard.prompt.discard-changes-panel.prompt' | translate"
    [subLabel]="
        'dashboard.prompt.discard-changes-panel-subLabel.prompt' | translate
    "
    [confirmLabel]="'dashboard.prompt.delete-panel.confirm-button' | translate"
    [cancelLabel]="'dashboard.prompt.delete-panel.cancel-button' | translate"
></app-confirmation-window>
